var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',[_c('navbar')],1),_c('app-main'),_c('ai-footer'),_c('ai-notification'),_c('online-consult')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }